(function (angular) {
    'use strict';

    angular.module('app')
        .directive('inputTags', inputTags);

    function inputTags() {

        var link = function ($scope) {
            $scope.delimiter = $scope.delimiter || ' ';
            $scope.isFocused = false;
            $scope.inputValue = '';
            $scope.tags = $scope.ngModel;
            $scope.width = $scope.tags && $scope.tags.length ?($scope.inputValue.length + 2) * 10 : '100%';

            $scope.focusInput = focusInput;
            $scope.onFocus = onFocus;
            $scope.onKeyup = onKeyup;
            $scope.onKeydown = onKeydown;
            $scope.removeTag = removeTag;

            function focusInput() {
                angular.element(document.querySelector('#tags' + $scope.$id)).focus();
            }

            function onFocus(isFocused) {
                $scope.isFocused = isFocused;
                $scope.width = isFocused || $scope.tags.length ?($scope.inputValue.length + 2) * 10 : '100%';
            }

            function onKeyup() {
                $scope.width = ($scope.inputValue.length + 2) * 10;
            }

            function onKeydown(evt) {
                if (evt.key === $scope.delimiter) {
                    evt.preventDefault();
                    if ($scope.tags instanceof Array) {
                        $scope.tags.push($scope.inputValue);
                    } else {
                        $scope.tags = [$scope.inputValue];
                    }
                    $scope.inputValue = '';
                }

                if (evt.key === 'Backspace' && $scope.inputValue === '') {
                    evt.preventDefault();
                    $scope.tags.pop();
                }

                $scope.ngModel = $scope.tags || [];
            }

            function removeTag(ind) {
                $scope.tags.splice(ind, 1);
            }
        };

        return {
            restrict: 'E',
            templateUrl: 'directives/inputTags.html',
            transclude: true,
            link: link,
            scope: {
                placeholder: '@',
                delimiter: '@?',
                ngModel: '=',
            },
        };

    }

}(angular));